import { createWebHistory, createRouter } from 'vue-router';
import routes from './routes.js';
import { useAuthStore } from '../store/Auth.js';

let baseUrl = import.meta.env.BASE_URL

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
});

export function guard(to, from, next) {
  const authStore = useAuthStore();
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    return next({ name: 'homepage' });
  }
  // Customers can't change instances or plugins (SPECTR-270) - the API
  // refuses it too, this only keeps them off pages that would fail.
  if (to.meta.requiresAdmin && !authStore.isAdmin) {
    return next({ name: 'dashboard' });
  }
  return next();
}

router.beforeEach(guard);

export default router;
